import { useMemo } from 'react'
import useDeveloperOptionsActions from '../functionalities/developer-options/useDeveloperOptionsActions'

let totalClicksCounter = 0
let clickExpireTimer: NodeJS.Timeout | undefined = undefined

export default function useEnterDevModeActions() {
    const { setDeveloperMode } = useDeveloperOptionsActions()

    return useMemo(() => {
        const countClick = () => {
            clearTimeout(clickExpireTimer)
            totalClicksCounter += 1
            clickExpireTimer = setTimeout(() => {
                totalClicksCounter = 0
            }, 300)

            // console.log(`totalClicksCounter=${totalClicksCounter}`)

            if (totalClicksCounter >= 5) {
                totalClicksCounter = 0
                setDeveloperMode(true)
            }
        }

        return {
            countClick,
        }
    }, [])
}
